<template>
  <div v-if="currentUser">
    <UnconfirmedMessage />
  </div>
</template>

<script>
export default {
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login").catch(() => {});
    } else if (this.currentUser.blocked) {
      this.$store.dispatch("auth/logout");
    }
  },
};
</script>
